import { Postcode } from '@dreryk/address-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, PostcodeInput as PostcodeInputComponent } from '@dreryk/react-components';

type PostcodeInputProps = FieldControllerProps<'postcode', Postcode | null> & ClassNameProp;

export const PostcodeInput = (props: PostcodeInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <PostcodeInputComponent
         testId={props.name}
         label={commonTranslationKeys.addressData.zipCode}
         controller={controller}
         className={props.className}
      />
   );
};
